import { cn } from '@cobliteam/ui/utils';
import type { Variants } from 'motion/react';
import { m } from 'motion/react';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

export interface MapIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

interface MapIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  isHovered: boolean;
}

const mapVariants: Variants = {
  normal: {
    opacity: 1,
  },
  animate: {
    opacity: 1,
  },
};

const linesVariants: Variants = {
  normal: {
    pathLength: 1,
    opacity: 1,
    transition: { duration: 0.3, ease: 'easeInOut' },
  },
  animate: {
    pathLength: [0, 1],
    opacity: 1,
    transition: { duration: 0.5, ease: 'easeInOut' },
  },
};

const pathVariants: Variants = {
  normal: {
    pathLength: 1,
    opacity: 1,
    transition: { duration: 0.3, ease: 'easeInOut' },
  },
  animate: {
    pathLength: [0, 1],
    opacity: 1,
    transition: { duration: 0.5, ease: 'easeInOut' },
  },
};

const MapIcon = forwardRef<MapIconHandle, MapIconProps>(({ onMouseEnter, onMouseLeave, className, size = 28, isHovered, ...props }, ref) => {
  const variant = isHovered ? 'animate' : 'normal';

  return (
    <div className={cn('relative overflow-hidden', className)} style={{ width: size, height: size }} {...props}>
      <m.svg
        data-testid='lucide-map'
        xmlns='http://www.w3.org/2000/svg'
        width={18}
        height={18}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        variants={mapVariants}
        animate={variant}
        className='absolute'
      >
        <m.path
          d='M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z'
          variants={pathVariants}
          animate={variant}
        />
        <m.path d='M15 5.764v15' variants={linesVariants} animate={variant} />
        <m.path d='M9 3.236v15' variants={linesVariants} animate={variant} />
      </m.svg>
    </div>
  );
});

MapIcon.displayName = 'MapIcon';

export { MapIcon };
